/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import {ProjectActions} from '../../actions/project';
import {connect} from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import {Map, List} from 'immutable';
import { createSelector } from 'reselect';
import { getComponent, getComponentDefaultValue } from '../types/Components';
import { validateAndDispatch } from '../../helpers/form';
import ComponentsSelect from '../types/ComponentsSelect';
import InputField from '../form/InputField';

const projectSelector = (state, props) => {
  const currentProjectId = state.projects.get('currentProjectId');
  const project = currentProjectId ? state.projects.getIn(['projects', currentProjectId], List()): null;
  return project;
}

const createProjectPropertyFormSelector = (state) => {
  const selector = formValueSelector('createProjectProperty');
  return selector(
    state,
    'propType',
    'propName',
    'propValue',
    'propDisplay'
  );
};

const CreateProjectPropertyModalSelector = createSelector(
  [projectSelector, createProjectPropertyFormSelector],
  (project, createProjectPropertyForm) => ({
    project,
    fields: createProjectPropertyForm,
    initialValues: {
      propType: 'string',
      propDisplay: true
    }
  })
);

@connect(CreateProjectPropertyModalSelector)
@reduxForm({
  form: 'createProjectProperty',
  destroyOnUnmount: false
})
export default class CreateProjectPropertyModal extends Component {
  static propTypes = {
    project: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    fields: PropTypes.object,
    reset: PropTypes.func,
    handleSubmit: PropTypes.func
  };

  submit = (values, dispatch) => {
    const { project, reset } = this.props;
    const projectId = project.get('id');
    // console.log('values', values);
    const validation = {
      propName: [{ rule: 'required', label: 'Property name' }]
    };

    const options = {
      props: {
        [values.propName]: {
          _type: values.propType,
          _value: values.propValue,
          _display: (values.propDisplay || false),
        }
      }
    };

    return validateAndDispatch(
      dispatch,
      ProjectActions.createCustomProperty(projectId, options),
      validation,
      values
    ).then(() => {
      reset();
    });
  }

  renderTypeComponent = () => {
    const {
      fields: {
        propType,
        propName,
        propValue,
      },
      dispatch,
    } = this.props;

    if (!propType) return <div />;

    const TypeComponent = getComponent(propType);

    return (<Field
      name="propValue"
      component={TypeComponent.editor}
      form="createProjectProperty"
      uid="createProjectProperty"
      propertyKey={propName}
      value={propValue}
      dispatch={dispatch}
    />);
  }

  render() {
    const {
      dispatch,
      handleSubmit,
      fields: {
        propType,
      }
    } = this.props;
    const TypeDefaultValue = getComponentDefaultValue(propType) || null;

    return (
      <div className="fs-modal-content">
        <h1>Add New Property</h1>
        <form>
          <div className="modal-form-wrapper">
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Name</label>
              <div className="col-sm-9 mb-2">
                <Field
                  name="propName"
                  type="input"
                  component={InputField}
                  className="form-control"
                  placeholder="Name of property"
                  style={{ marginBottom: 10 }}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Type</label>
              <div className="col-sm-9 mb-2">
                <Field
                  component={ComponentsSelect}
                  formName="createProjectProperty"
                  componentDefaultValue={TypeDefaultValue}
                  projectPropertiesComponents={true}
                  name="propType"
                  field="propType"
                  dispatch={dispatch}
                  style={{ display: 'block', height: 38 }}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-sm-3 col-form-label">Value</label>
              <div className="col-sm-9 mb-2">
                {this.renderTypeComponent()}
              </div>
            </div>
            <div className="form-group row mb-2">
              <label className="col-sm-3 col-form-label">Display</label>
              <div className="col-sm-9">
                <Field
                  className="mt-2"
                  name="propDisplay"
                  ref="propDisplay"
                  component="input"
                  type="checkbox"
                />
              </div>
            </div>
          </div>
          <div className="modal-form-button-wrapper">
            <button
              type="submit"
              className="btn btn-primary modal-submit-btn"
              onClick={handleSubmit(this.submit)}
            >
              Create Property
            </button>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CreateProjectPropertyModal.js